// Example of how to use environment variables in your application

// These variables are available because they're prefixed with VITE_
export const getEnvConfig = () => {
  const sneakPeakSecret = import.meta.env.VITE_SEAK_PEAK_SECRET;

  return {
    sneakPeakSecret,
  };
};

// Usage example:
// const config = getEnvConfig();
// console.log('API URL:', config.apiUrl);
